import InputNumber from '../input-number'

export default {
  name: 'KPaginationJumper',
  inject: ['context'],
  computed: {
    totalPage() {
      return this.context.totalPage
    },
    current: {
      get() {
        return this.context.current
      },
      set(value) {
        this.context.current = value
      },
    },
    disabled() {
      return this.context.disabled
    },
    small() {
      return this.context.small
    },
  },
  watch: {},
  methods: {
    handleInputChange(value) {
      this.current = value
    },
  },
  render() {
    return (
      <div class="km-pagination__jumper">
        前往
        <InputNumber
          class="km-pagination__jumper-input"
          size={this.small ? 'small' : null}
          disabled={this.disabled}
          min={this.current < 1 ? 0 : 1}
          max={this.totalPage}
          hideButton={true}
          value={this.current}
          onInput={this.handleInputChange}
        >
        </InputNumber>
        页
      </div>
    )
  },
}
